import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import './i18n'; // Initialize i18n

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  // Hydrate pre-rendered content from react-snap
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Normal render for development
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
